module.exports = __webpack_public_path__ + "img/1868.c182424c.gif";